export const LOCALE_CODE_CACHE_KEY = "lc"; // locale code

// Change the value of the following line if we want to clear the entire storage and reload the page
export const CACHE_VERSION = "1.7";
export const CACHE_VERSION_KEY = "cv";
